import { call, put, takeLatest } from 'redux-saga/effects';

import * as splashScreenActions from './splashScreenActions.js';
import { updateSplashScreenApiCall } from './splashScreenAPI.js';

function* updateSplashScreenSaga({ payload }) {
  try {
    const { data } = yield call(updateSplashScreenApiCall, payload);
    yield put(splashScreenActions.splashScreenUpdateStore(data));
  } catch (error) {
    yield put(splashScreenActions.splashScreenUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* splashScreenWatcher() {
  yield takeLatest(splashScreenActions.splashScreenUpdateRequest.type, updateSplashScreenSaga);
}
